import { ChatAssetInline } from "../StructuredCards/common/ChatAssetInline";
import { ChatStructuredAsset } from "@components/Chat/StructuredCards/types";
import { I18nUtil } from "@utils/i18n";
import type { JsonRenderSchemaAssetType } from "./type";
import { ScoreRingBadge } from "../../ScoreRingBadge";
import Translations from "@translate/components/Chat/JsonRenderComponents/AssetHeader";

const I18n = I18nUtil.createScoped(Translations);

export interface AssetHeaderProps {
  id?: string;
  assetLogo?: string;
  assetSymbol: string;
  title: string;
  assetScoreValue?: number;
  assetScoreTotal?: number;
  type: JsonRenderSchemaAssetType;
}

/**
 * 统一资产头组件。若同时提供 assetScoreValue 与 assetScoreTotal，按评分头样式渲染；否则按上下文标题样式渲染。 Figma（有评分样式）：81148:35902。 Figma（无评分样式）：81033:19293。
 * @param param0
 * @returns
 */
export const AssetHeader: React.FC<AssetHeaderProps> = ({
  id,
  assetLogo,
  assetSymbol,
  title,
  assetScoreValue,
  assetScoreTotal,
  type,
}) => {
  const nameInline = !assetScoreValue && !assetScoreTotal;
  const asset = {
    ...(id !== undefined && id !== "" ? { id } : {}),
    imageUrl: assetLogo ?? "",
    symbol: assetSymbol,
    name: title,
    scoreValue: assetScoreValue,
    scoreTotal: assetScoreTotal,
    schemaAssetType: type,
  } as ChatStructuredAsset;
  return (
    <div className="flex w-full items-start justify-between gap-2">
      <ChatAssetInline nameInline={nameInline} asset={asset} size="sm" />
      {!nameInline && (
        <ScoreRingBadge
          value={assetScoreValue || 0}
          max={assetScoreTotal}
          label={I18n.t("Score")}
        />
      )}
    </div>
  );
};
